import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {CategoryModel} from '@/libs/Api';
import {CategoriesDataService} from '@/libs/categories/categories-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const categoriesStore = registerCrudStore<CategoryModel, CategoryModel>(BusinessModule.Category, new CategoriesDataService());
